import Vue from 'vue'
import VueRouter from 'vue-router'

import Admin from '@/views/Admin'
import CallerPage from '@/views/CallerPage'
import Dashboard from '@/views/Dashboard'
import Directory from '@/views/Directory'
import Hour from '@/views/Hour'
import HourAdmin from '@/views/HourAdmin'
import JoinTeam from '@/views/JoinTeam'
import MenuLinksAdmin from '@/views/MenuLinksAdmin.vue'
import PasswordReset from '@/views/PasswordReset'
import Question from '@/views/Question'
import QuestionEdit from '@/views/QuestionEdit'
import SignIn from '@/views/SignIn'
import VisualAdmin from '@/views/VisualAdmin'
import firebase from 'firebase/app'
import 'firebase/auth'
import db from '@/plugins/db'

Vue.use(VueRouter)

const routes = [
  { path: '/',
    component: Dashboard,
    meta: { title: 'Meyerbase' },
  },
  { path: '/directory',
    component: Directory,
    meta: { title: 'Directory | Meyerbase' },
  },
  { path: '/admin',
    component: Admin,
    meta: { title: 'Admin | Meyerbase' },
    beforeEnter: function (to, from, next) {
      firebase.auth().onAuthStateChanged((user) => {
        db.ref(`users/${user.uid}`).once('value').then((snapshot) => {
          let person = snapshot.val()
          if (person.admin) {
            next()
          } else {
            next(from)
          }
        })
      })
    },
  },
  { path: '/admin/visuals',
    component: VisualAdmin,
    meta: { title: 'Visuals | Meyerbase' },
    beforeEnter: function (to, from, next) {
      firebase.auth().onAuthStateChanged((user) => {
        db.ref(`users/${user.uid}`).once('value').then((snapshot) => {
          let person = snapshot.val()
          if (person.admin) {
            next()
          } else {
            next(from)
          }
        })
      })
    },
  },
  { path: '/admin/hour',
    component: HourAdmin,
    meta: { title: 'Hour Admin | Meyerbase' },
    beforeEnter: function (to, from, next) {
      firebase.auth().onAuthStateChanged((user) => {
        db.ref(`users/${user.uid}`).once('value').then((snapshot) => {
          let person = snapshot.val()
          if (person.admin) {
            next()
          } else {
            next(from)
          }
        })
      })
    },
  },
  { path: '/admin/menu-links',
    component: MenuLinksAdmin,
    meta: { title: 'Menu Links Admin | Meyerbase' },
    beforeEnter: function (to, from, next) {
      firebase.auth().onAuthStateChanged((user) => {
        db.ref(`users/${user.uid}`).once('value').then((snapshot) => {
          let person = snapshot.val()
          if (person.admin) {
            next()
          } else {
            next(from)
          }
        })
      })
    },
  },
  { path: '/join-team',
    component: JoinTeam,
    meta: { title: 'Join | Meyerbase' },
  },
  { path: '/sign-in',
    component: SignIn,
    meta: { title: 'Login | Meyerbase' },
  },
  { path: '/password-reset',
    component: PasswordReset,
    meta: { title: 'Password Reset | Meyerbase' },
  },
  { path: '/hour/:id',
    component: Hour,
  },
  { path: '/hour/:id/question/:key',
    component: Question,
  },
  { path: '/hour/:id/question/:key/edit',
    component: QuestionEdit,
  },
  { path: '/caller',
    component: CallerPage,
    meta: { title: 'Caller | Meyerbase' },
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.path.substring(1, 5).toLowerCase() === 'http') {
    window.location.replace(to.path.substring(1))
  }

  firebase.auth().onAuthStateChanged((user) => {
    if ((to.path !== '/sign-in' &&
         to.path !== '/join-team' &&
         to.path !== '/password-reset') &&
        !user) {
      next('/sign-in')
    } else {
      next()
    }
  })
})

export default router
